/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeKoffermaticPerfActionDto,
  ApiEnvelopeKoffermaticPerfDirectiveDto,
  ApiEnvelopeKoffermaticPerfDirectiveListDto,
  ApiEnvelopeKoffermaticPerfReportDetailDto,
  ApiEnvelopeKoffermaticPerfReportListDto,
  KoffermaticPerfAdminListParams,
  KoffermaticPerfDeepRequest,
  ProblemDetails
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type koffermaticPerfAdminListResponse200 = {
  data: ApiEnvelopeKoffermaticPerfReportListDto
  status: 200
}

export type koffermaticPerfAdminListResponse401 = {
  data: ApiEnvelopeKoffermaticPerfReportListDto
  status: 401
}

export type koffermaticPerfAdminListResponseSuccess = (koffermaticPerfAdminListResponse200) & {
  headers: Headers;
};
export type koffermaticPerfAdminListResponseError = (koffermaticPerfAdminListResponse401) & {
  headers: Headers;
};

export type koffermaticPerfAdminListResponse = (koffermaticPerfAdminListResponseSuccess | koffermaticPerfAdminListResponseError)

export const getKoffermaticPerfAdminListUrl = (params?: KoffermaticPerfAdminListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/koffermatic/admin/performance?${stringifiedParams}` : `/api/koffermatic/admin/performance`
}

export const useKoffermaticPerfAdminListHook = (): (params?: KoffermaticPerfAdminListParams, options?: RequestInit) => Promise<koffermaticPerfAdminListResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: KoffermaticPerfAdminListParams, options?: RequestInit) => {

        return customFetcher(getKoffermaticPerfAdminListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type koffermaticPerfAdminDetailResponse200 = {
  data: ApiEnvelopeKoffermaticPerfReportDetailDto
  status: 200
}

export type koffermaticPerfAdminDetailResponse401 = {
  data: ApiEnvelopeKoffermaticPerfReportDetailDto
  status: 401
}

export type koffermaticPerfAdminDetailResponse404 = {
  data: ApiEnvelopeKoffermaticPerfReportDetailDto
  status: 404
}

export type koffermaticPerfAdminDetailResponseSuccess = (koffermaticPerfAdminDetailResponse200) & {
  headers: Headers;
};
export type koffermaticPerfAdminDetailResponseError = (koffermaticPerfAdminDetailResponse401 | koffermaticPerfAdminDetailResponse404) & {
  headers: Headers;
};

export type koffermaticPerfAdminDetailResponse = (koffermaticPerfAdminDetailResponseSuccess | koffermaticPerfAdminDetailResponseError)

export const getKoffermaticPerfAdminDetailUrl = (reportId: string,) => {




  return `/api/koffermatic/admin/performance/${reportId}`
}

export const useKoffermaticPerfAdminDetailHook = (): (reportId: string, options?: RequestInit) => Promise<koffermaticPerfAdminDetailResponse> => {

      const customFetcher = useSfetchMutator();
      return (reportId: string, options?: RequestInit) => {

        return customFetcher(getKoffermaticPerfAdminDetailUrl(reportId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type koffermaticPerfAdminDeleteResponse200 = {
  data: ApiEnvelopeKoffermaticPerfActionDto
  status: 200
}

export type koffermaticPerfAdminDeleteResponse401 = {
  data: ApiEnvelopeKoffermaticPerfActionDto
  status: 401
}

export type koffermaticPerfAdminDeleteResponse404 = {
  data: ApiEnvelopeKoffermaticPerfActionDto
  status: 404
}

export type koffermaticPerfAdminDeleteResponseSuccess = (koffermaticPerfAdminDeleteResponse200) & {
  headers: Headers;
};
export type koffermaticPerfAdminDeleteResponseError = (koffermaticPerfAdminDeleteResponse401 | koffermaticPerfAdminDeleteResponse404) & {
  headers: Headers;
};

export type koffermaticPerfAdminDeleteResponse = (koffermaticPerfAdminDeleteResponseSuccess | koffermaticPerfAdminDeleteResponseError)

export const getKoffermaticPerfAdminDeleteUrl = (reportId: string,) => {




  return `/api/koffermatic/admin/performance/${reportId}`
}

export const useKoffermaticPerfAdminDeleteHook = (): (reportId: string, options?: RequestInit) => Promise<koffermaticPerfAdminDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (reportId: string, options?: RequestInit) => {

        return customFetcher(getKoffermaticPerfAdminDeleteUrl(reportId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type koffermaticPerfAdminDirectivesResponse200 = {
  data: ApiEnvelopeKoffermaticPerfDirectiveListDto
  status: 200
}

export type koffermaticPerfAdminDirectivesResponse401 = {
  data: ApiEnvelopeKoffermaticPerfDirectiveListDto
  status: 401
}

export type koffermaticPerfAdminDirectivesResponseSuccess = (koffermaticPerfAdminDirectivesResponse200) & {
  headers: Headers;
};
export type koffermaticPerfAdminDirectivesResponseError = (koffermaticPerfAdminDirectivesResponse401) & {
  headers: Headers;
};

export type koffermaticPerfAdminDirectivesResponse = (koffermaticPerfAdminDirectivesResponseSuccess | koffermaticPerfAdminDirectivesResponseError)

export const getKoffermaticPerfAdminDirectivesUrl = () => {




  return `/api/koffermatic/admin/performance/directives`
}

export const useKoffermaticPerfAdminDirectivesHook = (): ( options?: RequestInit) => Promise<koffermaticPerfAdminDirectivesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getKoffermaticPerfAdminDirectivesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type koffermaticPerfAdminRequestDeepProfileResponse200 = {
  data: ApiEnvelopeKoffermaticPerfDirectiveDto
  status: 200
}

export type koffermaticPerfAdminRequestDeepProfileResponse401 = {
  data: ApiEnvelopeKoffermaticPerfDirectiveDto
  status: 401
}

export type koffermaticPerfAdminRequestDeepProfileResponseSuccess = (koffermaticPerfAdminRequestDeepProfileResponse200) & {
  headers: Headers;
};
export type koffermaticPerfAdminRequestDeepProfileResponseError = (koffermaticPerfAdminRequestDeepProfileResponse401) & {
  headers: Headers;
};

export type koffermaticPerfAdminRequestDeepProfileResponse = (koffermaticPerfAdminRequestDeepProfileResponseSuccess | koffermaticPerfAdminRequestDeepProfileResponseError)

export const getKoffermaticPerfAdminRequestDeepProfileUrl = (installId: string,) => {




  return `/api/koffermatic/admin/performance/directives/${installId}`
}

export const useKoffermaticPerfAdminRequestDeepProfileHook = (): (installId: string,
    koffermaticPerfDeepRequest?: KoffermaticPerfDeepRequest, options?: RequestInit) => Promise<koffermaticPerfAdminRequestDeepProfileResponse> => {

      const customFetcher = useSfetchMutator();
      return (installId: string,
    koffermaticPerfDeepRequest?: KoffermaticPerfDeepRequest, options?: RequestInit) => {

        return customFetcher(getKoffermaticPerfAdminRequestDeepProfileUrl(installId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(koffermaticPerfDeepRequest)
  }
);
      }
  }


export type koffermaticPerfAdminClearDeepProfileResponse200 = {
  data: ApiEnvelopeKoffermaticPerfActionDto
  status: 200
}

export type koffermaticPerfAdminClearDeepProfileResponse401 = {
  data: ApiEnvelopeKoffermaticPerfActionDto
  status: 401
}

export type koffermaticPerfAdminClearDeepProfileResponse404 = {
  data: ApiEnvelopeKoffermaticPerfActionDto
  status: 404
}

export type koffermaticPerfAdminClearDeepProfileResponseSuccess = (koffermaticPerfAdminClearDeepProfileResponse200) & {
  headers: Headers;
};
export type koffermaticPerfAdminClearDeepProfileResponseError = (koffermaticPerfAdminClearDeepProfileResponse401 | koffermaticPerfAdminClearDeepProfileResponse404) & {
  headers: Headers;
};

export type koffermaticPerfAdminClearDeepProfileResponse = (koffermaticPerfAdminClearDeepProfileResponseSuccess | koffermaticPerfAdminClearDeepProfileResponseError)

export const getKoffermaticPerfAdminClearDeepProfileUrl = (installId: string,) => {




  return `/api/koffermatic/admin/performance/directives/${installId}`
}

export const useKoffermaticPerfAdminClearDeepProfileHook = (): (installId: string, options?: RequestInit) => Promise<koffermaticPerfAdminClearDeepProfileResponse> => {

      const customFetcher = useSfetchMutator();
      return (installId: string, options?: RequestInit) => {

        return customFetcher(getKoffermaticPerfAdminClearDeepProfileUrl(installId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type koffermaticPerfAdminDownloadResponse200 = {
  data: Blob
  status: 200
}

export type koffermaticPerfAdminDownloadResponse404 = {
  data: ProblemDetails
  status: 404
}

export type koffermaticPerfAdminDownloadResponseSuccess = (koffermaticPerfAdminDownloadResponse200) & {
  headers: Headers;
};
export type koffermaticPerfAdminDownloadResponseError = (koffermaticPerfAdminDownloadResponse404) & {
  headers: Headers;
};

export type koffermaticPerfAdminDownloadResponse = (koffermaticPerfAdminDownloadResponseSuccess | koffermaticPerfAdminDownloadResponseError)

export const getKoffermaticPerfAdminDownloadUrl = (reportId: string,) => {




  return `/api/koffermatic/admin/performance/${reportId}/download`
}

export const useKoffermaticPerfAdminDownloadHook = (): (reportId: string, options?: RequestInit) => Promise<koffermaticPerfAdminDownloadResponse> => {

      const customFetcher = useSfetchMutator();
      return (reportId: string, options?: RequestInit) => {

        return customFetcher(getKoffermaticPerfAdminDownloadUrl(reportId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


